import { Injectable } from '@angular/core';
declare let THREE: any;
@Injectable()
export class SegmentsIntersectService {

  constructor() { }

  isIntersected(pointA1, pointA2, pointB1, pointB2) {
    if (pointA1.x - pointA2.x == pointB1.x - pointB2.x || pointA1.x - pointA2.x == pointB2.x - pointB1.x) {
      pointA1.x += 5;
      pointA1.y += 5;
    }

    var vector1 = new THREE.Vector2(pointB1.x - pointA1.x, pointB1.y - pointA1.y);
    var vector2 = new THREE.Vector2(pointB1.x - pointA2.x, pointB1.y - pointA2.y);
    var vector3 = new THREE.Vector2(pointB2.x - pointA1.x, pointB2.y - pointA1.y);
    var vector4 = new THREE.Vector2(pointB2.x - pointA2.x, pointB2.y - pointA2.y);

    var tr1 = Math.abs(vector1.x * vector2.y - vector1.y * vector2.x);
    var tr2 = Math.abs(vector3.x * vector4.y - vector3.y * vector4.x);
    var tr3 = Math.abs(vector1.x * vector3.y - vector1.y * vector3.x);
    var tr4 = Math.abs(vector4.x * vector2.y - vector4.y * vector2.x);


    if (tr1 + tr2 === tr3 + tr4) {//} - 1 && tr1 + tr2 <= tr3 + tr4 + 1) {

      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/segments-intersect.service.ts